import { SERVER_URL } from "./client";

// Eden Treaty cannot express the dashed route segments the tracking endpoints
// use (`/analytics/top-queries`, `/recommendations/product-search`), so those
// pages go through this thin wrapper instead. Same credentials behaviour.

export const fetchJson = async <T>(path: string): Promise<T> => {
	const res = await fetch(`${SERVER_URL}${path}`, { credentials: "include" });
	if (!res.ok) {
		// Without the body a 500 reaches the UI as a bare status code, which is
		// all anyone could see the last time these pages broke.
		const detail = await res.text().catch(() => "");
		throw new Error(
			`${path} → ${res.status}${detail ? `: ${detail.slice(0, 300)}` : ""}`,
		);
	}
	return res.json() as Promise<T>;
};

export const sendJson = async <T>(
	path: string,
	method: "POST" | "PUT" | "PATCH" | "DELETE",
	body?: unknown,
): Promise<T> => {
	const res = await fetch(`${SERVER_URL}${path}`, {
		method,
		credentials: "include",
		headers: { "Content-Type": "application/json" },
		body: body === undefined ? undefined : JSON.stringify(body),
	});
	if (!res.ok) {
		const detail = await res.text().catch(() => "");
		throw new Error(
			`${path} → ${res.status}${detail ? `: ${detail.slice(0, 200)}` : ""}`,
		);
	}
	return res.json() as Promise<T>;
};
